module.exports = __webpack_public_path__ + "static/AtlasGrotesk-Regular-Web-ab1b89215a7b412c97d8ef621db7d0e8.woff";